import { useState } from "react";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { MoneyInput, Notice } from "../../lib/ui";
import "./inventory.css";

/*
 * Add product – port of addProduct.php (API: POST /api/products, backend/stock.py)
 * Retail / wholesale mode decides which unit becomes unit_of_measurement. Barcode, name,
 * purchase price (> 0), quantity and minimum stock are required.
 */

const TYPES = ["Beverages", "Snacks", "Personal Care", "Baby Products", "Household Essentials", "Cooking Ingredients",
  "Canned & Packaged Foods", "Electronics Accessories", "Beauty Products", "Stationery"];
const RETAIL_UNITS = [["pcs", "Pieces (pcs)"], ["bottle", "Bottle"], ["sachet", "Sachet"], ["packet", "Packet"]];
const WHOLESALE_UNITS = [["box", "Box"], ["carton", "Carton"], ["crate", "Crate"], ["pack", "Pack"]];
const BLANK = { barcode: "", product_name: "", manufacturer: "", product_type: "", expiry_date: "", purchase_price: "",
  retail_price: "", retail_unit: "", wholesale_price: "", wholesale_unit: "", wholesale_pack_size: "", quantity: "", minimum_stock: "" };

export default function AddProduct() {
  const api = useApi();
  const [mode, setMode] = useState("retail");
  const [f, setF] = useState(BLANK);
  const [notice, setNotice] = useState(null);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const setMoney = (k) => (v) => setF((s) => ({ ...s, [k]: v }));

  const save = async (e) => {
    e.preventDefault();
    setBusy(true); setNotice(null);
    try {
      const r = await api.post("/api/products", { ...f, product_mode: mode });
      setNotice({ tone: "ok", text: `${r.message} (${f.product_name})` });
      setF(BLANK);
      document.getElementById("ap-barcode")?.focus();
    } catch (err) { setNotice({ tone: "err", text: err.message }); }
    finally { setBusy(false); }
  };

  return (
    <main className="pg" style={{ maxWidth: "64rem" }}>
      <PageHeader slug="productAdd" actions={
        <div className="ap-mode" role="group" aria-label="Product mode">
          <button type="button" aria-pressed={mode === "retail"} onClick={() => setMode("retail")}>Retail</button>
          <button type="button" aria-pressed={mode === "wholesale"} onClick={() => setMode("wholesale")}>Wholesale</button>
        </div>} />
      <Notice notice={notice} onClose={() => setNotice(null)} />
      <div className="panel">
        <form className="form three" onSubmit={save}>
          <div className="field full"><label htmlFor="ap-barcode">Barcode<span className="req">*</span></label>
            <input id="ap-barcode" required autoFocus value={f.barcode} onChange={set("barcode")} placeholder="Scan or enter barcode" autoComplete="off" /></div>
          <div className="field"><label htmlFor="ap-name">Product name<span className="req">*</span></label><input id="ap-name" required value={f.product_name} onChange={set("product_name")} /></div>
          <div className="field"><label htmlFor="ap-mfr">Manufacturer</label><input id="ap-mfr" value={f.manufacturer} onChange={set("manufacturer")} /></div>
          <div className="field"><label htmlFor="ap-type">Product type<span className="req">*</span></label>
            <select id="ap-type" required value={f.product_type} onChange={set("product_type")}>
              <option value="">Select type</option>{TYPES.map((t) => <option key={t}>{t}</option>)}
            </select></div>
          <div className="field"><label htmlFor="ap-exp">Expiry date</label><input id="ap-exp" type="date" value={f.expiry_date} onChange={set("expiry_date")} /></div>
          <div className="field"><label htmlFor="ap-pp">Purchase price<span className="req">*</span></label>
            <MoneyInput id="ap-pp" required value={f.purchase_price} onChange={setMoney("purchase_price")} /></div>
          {mode === "retail" ? (
            <>
              <div className="field"><label htmlFor="ap-rp">Retail price<span className="req">*</span></label>
                <MoneyInput id="ap-rp" required value={f.retail_price} onChange={setMoney("retail_price")} /></div>
              <div className="field"><label htmlFor="ap-ru">Retail unit<span className="req">*</span></label>
                <select id="ap-ru" required value={f.retail_unit} onChange={set("retail_unit")}>
                  <option value="">Select unit</option>{RETAIL_UNITS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                </select></div>
            </>
          ) : (
            <>
              <div className="field"><label htmlFor="ap-wp">Wholesale price<span className="req">*</span></label>
                <MoneyInput id="ap-wp" required value={f.wholesale_price} onChange={setMoney("wholesale_price")} /></div>
              <div className="field"><label htmlFor="ap-wu">Wholesale unit<span className="req">*</span></label>
                <select id="ap-wu" required value={f.wholesale_unit} onChange={set("wholesale_unit")}>
                  <option value="">Select unit</option>{WHOLESALE_UNITS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                </select></div>
              <div className="field"><label htmlFor="ap-ps">Pack size</label><input id="ap-ps" type="number" min="1" value={f.wholesale_pack_size} onChange={set("wholesale_pack_size")} /></div>
            </>
          )}
          <div className="field"><label htmlFor="ap-qty">Quantity<span className="req">*</span></label><input id="ap-qty" type="number" min="0" required value={f.quantity} onChange={set("quantity")} /></div>
          <div className="field"><label htmlFor="ap-min">Minimum stock<span className="req">*</span></label><input id="ap-min" type="number" min="0" required value={f.minimum_stock} onChange={set("minimum_stock")} /></div>
          <div className="form-actions"><button type="submit" className="btn primary" disabled={busy}><i className="fas fa-check" /> {busy ? "Saving…" : "Save product"}</button></div>
        </form>
      </div>
    </main>
  );
}
